import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsObjectViewEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-object-v2/src/assetsObjectViewEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { insightObjectResource } from '@jira/router-resources__servicedesk-cmdb-object/src/insightObjectResource.tsx';
import { assetsObjectRoute } from '@jira/router-routes__assets-app-routes/src/assetsObjectRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsObjectPageEntryPoint = createChromelessEntryPoint({
	main: assetsObjectViewEntryPoint,
});

export const assetsObjectRouteEntry: Route = createEntry(assetsObjectRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	entryPoint: () => assetsObjectPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-object-v2',
	resources: [...getAssetsAppResources(), insightObjectResource],
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
	ufoName: 'assets-object-view-page',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
